<template>
  <div>
    <lv-button
      styling="small-secondary-dark-just-icon"
      :aria-label="$awt(ariaLabelPrev)"
      @click="$emit('prev')"
    >
      <lv-icon name="arrow-left-16" :size="16" style="vertical-align: unset;" />
    </lv-button>
    <lv-button
      styling="small-secondary-dark-just-icon"
      :aria-pressed="!isPaused"
      :aria-label="$awt(ariaLabelToggle)"
      @click="$emit('toggle-pause')"
    >
      <lv-icon
        v-if="isPaused"
        :size="16"
        name="play-version2-16"
        style="vertical-align: unset;"
      />
      <lv-icon
        v-else
        :size="16"
        name="pause-version2-16"
        style="vertical-align: unset;"
      />
    </lv-button>
    <lv-button
      styling="small-secondary-dark-just-icon"
      :aria-label="$awt(ariaLabelNext)"
      @click="$emit('next')"
    >
      <lv-icon name="arrow-right-16" :size="16" style="vertical-align: unset;" />
    </lv-button>
  </div>
</template>

<script setup>
  import { LvButton, LvIcon } from '~~/common/components/loginet-vue-shop/index';

  defineProps({
    isPaused: {
      type: Boolean,
      required: true,
      default: false,
    },
    ariaLabelPrev: {
      type: String,
      default: 'aw.cms.carousel_v3.image_only.prev',
    },
    ariaLabelToggle: {
      type: String,
      default: 'aw.cms.carousel_v3.image_only.toggle',
    },
    ariaLabelNext: {
      type: String,
      default: 'aw.cms.carousel_v3.image_only.next',
    },
  });
  defineEmits([
    'prev',
    'toggle-pause',
    'next',
  ]);
</script>
